import { Faq16, UIText2, Tooltip } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './priceAuction.css';

export const PriceAuction = () => {
  return (
    <div className={styles['actual']}>
      <div className={styles['label']}>
        <UIText2 color="gray60_100">Начальная цена, аукцион</UIText2>
      </div>
      <Tooltip
        theme="white"
        placement="bottom"
        title={
          <div className={styles['description']}>
            <UIText2>Объект реализуется через проведение торгов в соответствии с&nbsp;ГК РФ.</UIText2>
            <a
              className={styles['link']}
              href="https://hc.cian.ru/hc/ru/articles/360037867052"
              target="_blank"
              rel="noopener noreferrer"
            >
              Справочная информация
            </a>
          </div>
        }
      >
        <Faq16 color="primary_100" />
      </Tooltip>
    </div>
  );
};

PriceAuction.displayName = 'PriceAuction';
